/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Tab_InventoryInputs */

const vi_report_tab_inventory = /** @type {(inputs: Report_Tab_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn kho`)
};

/**

* @param {Report_Tab_InventoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_tab_inventory = /** @type {((inputs?: Report_Tab_InventoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Tab_InventoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_tab_inventory(inputs)
});